import { Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { secureOpenUrl } from '@/utils/linkValidation';

const TTRDPPricingSection = () => {
  // Convert USD to TTD (1 USD = 6.75 TTD)
  const rdpPlans = [
    {
      name: "RDP Basic",
      cpu: "2 vCores",
      ram: "4 GB RAM",
      storage: "80 GB SSD", 
      price: "$101.25 TTD",
      usdPrice: "$15 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/rdp"
    },
    {
      name: "RDP Standard", 
      cpu: "4 vCores",
      ram: "8 GB RAM",
      storage: "160 GB SSD",
      price: "$202.50 TTD",
      usdPrice: "$30 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/rdp"
    },
    {
      name: "RDP Premium",
      cpu: "6 vCores", 
      ram: "16 GB RAM",
      storage: "320 GB SSD",
      price: "$405.00 TTD",
      usdPrice: "$60 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/rdp"
    }
  ];

  const TTRDPCard = ({ rdp, index }: { rdp: any, index: number }) => (
    <div 
      className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="text-center mb-6">
        <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
          <Monitor className="h-8 w-8 text-red-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900">{rdp.name}</h3>
      </div>

      <div className="space-y-3 mb-6">
        <div className="flex justify-between">
          <span className="text-gray-600">CPU:</span>
          <span className="font-semibold">{rdp.cpu}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">RAM:</span>
          <span className="font-semibold">{rdp.ram}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Storage:</span>
          <span className="font-semibold">{rdp.storage}</span>
        </div>
      </div>

      <div className="text-center mb-6">
        <div className="text-2xl font-bold text-red-600 mb-1">
          🇹🇹 {rdp.price}
        </div>
        <div className="text-sm text-gray-500">
          (was {rdp.usdPrice})
        </div>
      </div>

      <div className="space-y-2 mb-6">
        <div className="flex items-center text-sm text-gray-600">
          <span className="text-green-500 mr-2">✓</span>
          Windows Server 2022
        </div>
        <div className="flex items-center text-sm text-gray-600">
          <span className="text-green-500 mr-2">✓</span>
          24/7 Admin Access
        </div>
        <div className="flex items-center text-sm text-gray-600">
          <span className="text-green-500 mr-2">✓</span>
          US Residential IP
        </div>
        <div className="flex items-center text-sm text-gray-600">
          <span className="text-green-500 mr-2">✓</span>
          Perfect for Trading
        </div>
      </div>

      <Button 
        onClick={() => secureOpenUrl(rdp.link)}
        className="w-full bg-red-600 hover:bg-red-700 text-white"
      >
        Order Now - Pay in TTD
      </Button>
    </div>
  );

  return (
    <section className="py-12 bg-gray-50/50 rounded-xl mb-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            US Residential Remote Desktops - TTD Pricing
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Perfect for forex trading, business applications, and remote work. Pay in Trinidad & Tobago Dollars.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {rdpPlans.map((rdp, index) => (
            <TTRDPCard key={index} rdp={rdp} index={index} />
          ))}
        </div>

        <div className="text-center mt-8 p-4 bg-red-50 rounded-lg border border-red-200">
          <p className="text-red-800 font-semibold">
            🏦 Ideal for forex trading & business - Contact us for TTD payment options!
          </p>
        </div>
      </div>
    </section>
  );
};

export default TTRDPPricingSection;